export enum Timezone {
  Eastern = "Eastern",
  Central = "Central",
  Mountain = "Mountain",
  Pacific = "Pacific",
  Alaskan = "Alaskan",
  Hawaiian = "Hawaiian",
}
